import { server_connection } from 'config';
import { getAllLessons as courseGetLessons } from '../../../course/store/actions';
import { getRelatedData as courseRelatedData } from '../../../course/store/actions';
import { getContentLabelList } from '../../../content_label/store/actions';
import store from 'store';
import history from 'history.js';

export const GET_LESSON = '[LESSON APP] GET LESSON';
export const GET_LESSON_LIST = '[LESSON APP] GET LESSON LIST';
export const UPDATE_LESSON_LIST_LOADED = '[LESSON APP] UPDATE LESSON LIST LOADED';
export const DELETE_LESSON = '[LESSON APP] DELETE LESSON';
export const SAVE_LESSON = '[LESSON APP] SAVE LESSON';
export const UPDATE_LESSON_LOADED = '[LESSON APP] UPDATE LESSON LOADED';
export const GET_LESSON_DATA = '[LESSON APP] GET LESSON DATA';
export const UPDATE_LESSON_FORM = '[LESSON APP] UPDATE LESSON FORM';
export const GET_RELATED_DATA = '[LESSON APP] GET RELATED DATA';
export const GET_LESSON_ASSET_LIST = '[LESSON APP] GET LESSON ASSET LIST';
export const CHECK_ALLOW_DELETE = '[LESSON APP] CHECK ALLOW DELETE';
export const CLEAR_SCHEDULE = '[LESSON APP] CLEAR SCHEDULE';
export const ACTIVATE_LESSON = '[LESSON APP] ACTIVATE LESSON';

export const LOCK_LESSON = '[LESSON APP] LOCK LESSON';
export const UNLOCK_LESSON = '[LESSON APP] UNLOCK LESSON';

// LESSON -> Assignment relational
export const GET_ALL_ASSIGNMENTS = '[LESSON APP] GET ALL ASSIGNMENTS';
export const TOGGLE_ASSIGNMENT = '[LESSON APP] TOGGLE ASSIGNMENT';

// Lesson -> Quiz relational
export const GET_ALL_QUIZZES = '[LESSON APP] GET ALL QUIZZES';
export const TOGGLE_QUIZ = '[LESSON APP] TOGGLE QUIZ';

export const SAVE_SCHEDULE = '[LESSON APP] SAVE SCHEDULE';
export const UPDATE_EVENT = '[LESSON APP] UPDATE EVENT';
export const CHECK_EVENT_ADD = '[LESSON APP] CHECK EVENT ADD';
export const PREPARE_DISPLAY_ORDERS = '[LESSON APP] PREPARE_DISPLAY_ORDERS';
export const MOVE_CARD = '[LESSON APP] MOVE CARD';
export const REMOVE_EVENT_FROM_CALENDAR = '[LESSON APP] REMOVE EVENT FROM CALENDAR';

export const ADD_UNSCHEDULED_EVENT = '[LESSON APP] ADD UNSCHEDULED EVENT';
export const MOVE_UNSCHEDULED_EVENT = '[LESSON APP] MOVE UNSCHEDULED EVENT';
export const REMOVE_UNSCHEDULED_EVENT = '[LESSON APP] REMOVE UNSCHEDULED EVENT';
export const SET_UNSCHEDULED_EVENT_RELATION = '[LESSON APP] SET UNSCHEDULED EVENT RELATION';

export const ADD_UNSCHEDULED_EVENT_OLD = '[LESSON APP] ADD UNSCHEDULED EVENT OLD';
export const TOGGLE_COMPANY = '[LESSON APP] TOGGLE COMPANY';
export const COMPANY_UPDATE_SEARCH = '[LESSON APP] COMPANY UPDATE SEARCH';

export const GET_COMPANY_LIST = '[LESSON APP] GET COMPANY LIST';
export const UPDATE_ASSET_NAME = '[LESSON APP] UPDATE ASSET NAME';
export const UPDATE_NEW_LESSON_NAME = '[LESSON APP] UPDATE NEW LESSON NAME';
export const TOGGLE_LESSON_REPULL = '[LESSON APP] TOGGLE LESSON REPULL';

export function updateLessonLoaded(setting) {
    return {
        type: UPDATE_LESSON_LOADED,
        payload: setting
    }
}

export function updateLessonListLoaded(setting) {
    return {
        type: UPDATE_LESSON_LIST_LOADED,
        payload: setting
    }
}

export function updateLessonForm(lesson_data) {
    return {
        type: UPDATE_LESSON_FORM,
        payload: lesson_data
    }
}

export function getLessonData(lesson_id) {
    return (dispatch) => {
        Promise.all([
            dispatch(getLesson(lesson_id)),
            dispatch(getRelatedData(lesson_id)),
            dispatch(getAllAssignments()),
            dispatch(getAllQuizzes()),
            dispatch(getLessonAssetList(lesson_id)),
            dispatch(getContentLabelList())
        ]).then(
            () => dispatch(updateLessonLoaded(true))
        )
    }
}

export function getCompanyList() {
    return (dispatch, getState) => {
        fetch(server_connection + '/company/list')
            .then((response) => response.json())
            .then((companyList) => {
                dispatch({
                    type: GET_COMPANY_LIST,
                    payload: companyList,
                });
            });
    }
}


export function getLesson(lesson_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/lesson/get/' + lesson_id)
            .then((response) => response.json())
            .then((lessonData) => {
                dispatch({
                    type: GET_LESSON,
                    payload: lessonData,
                });
            });
    }
}

export function getLessonAssetList(lesson_id, assetInsertResponse = []) {
    return (dispatch) => {
        fetch(server_connection + '/lesson/asset_list/' + lesson_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_LESSON_ASSET_LIST,
                    payload: { responseData, assetInsertResponse }
                });
            });
    }
}

export function deleteLesson(lesson_id, paramHistory) {
    const auth_id = store.getState().auth.user.data.auth_id;
    return (dispatch, getState) => {
        fetch(server_connection + '/lesson/delete',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ lesson_id: lesson_id, auth_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: DELETE_LESSON,
                    payload: lesson_id,
                });
                if (paramHistory.active) {
                    dispatch(courseGetLessons())
                    dispatch(courseRelatedData(paramHistory.course_id))
                }

            });
    }
}

export function saveLesson(lesson, assignments, quizzes, unscheduledEvents, auth_id, companies) {
    const newLesson = { ...lesson, CreateAuthID: auth_id, LastEditAuthID: auth_id, companies }

    return async (dispatch, getState) => {
        let unscheduledEventsDisplayOrder = unscheduledEvents.map((event, index) => {
            return {
                ...event,
                DisplayOrder: index + 1
            }
        })
        await fetch(server_connection + '/lesson/save',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    lesson: newLesson,
                    quiz_list: quizzes,
                    assignment_list: assignments,
                    unscheduledAssignments: unscheduledEventsDisplayOrder.filter((e) => e.eventType === 'assignment'),
                    unscheduledQuizzes: unscheduledEventsDisplayOrder.filter((e) => e.eventType === 'quiz'),
                    companies
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getLessonList('actions'));
                dispatch(courseGetLessons(auth_id));
            });
    }
}



export function getLessonList(call_location) {
    const a = store.getState().auth.user.data.auth_id;
    return (dispatch, getState) => {
        fetch(server_connection + '/lesson/list/' + a)
            .then((response) => response.json())
            .then((lessonList) => {
                dispatch({
                    type: GET_LESSON_LIST,
                    payload: { lessonList, call_location }
                });
            });
    }
}

export function getRelatedData(lesson_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/lesson/data/' + lesson_id)
            .then((response) => response.json())
            .then((relatedData) => {
                dispatch({
                    type: GET_RELATED_DATA,
                    payload: relatedData
                })
            })
    }
}

// LESSON -> Assignment

export function getAllAssignments() {
    const auth_id = store.getState().auth.user.data.auth_id;
    return (dispatch) => {
        return fetch(server_connection + '/assignment/list/' + auth_id)
            .then((response) => response.json())
            .then((allAssignments) => {
                return dispatch({
                    type: GET_ALL_ASSIGNMENTS,
                    payload: allAssignments
                })
            })
    }
}

// LESSON -> Quiz

export function getAllQuizzes() {
    const auth_id = store.getState().auth.user.data.auth_id;
    return (dispatch) => {
        return fetch(server_connection + '/quiz/list/' + auth_id)
            .then((response) => response.json())
            .then((allQuizzes) => {
                return dispatch({
                    type: GET_ALL_QUIZZES,
                    payload: allQuizzes
                })
            })
    }
}



export function saveSchedule(lesson_id, assignments, quizzes, unscheduledEvents) {
    return async (dispatch, getState) => {
        let unscheduledEventsDisplayOrder = unscheduledEvents.map((event, index) => {
            return {
                ...event,
                DisplayOrder: index + 1
            }
        })
        await fetch(server_connection + '/lesson/save/schedule',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    assignments: assignments,
                    quizzes: quizzes,
                    lesson_id: lesson_id,
                    unscheduledAssignments: unscheduledEventsDisplayOrder.filter((e) => e.eventType === 'assignment'),
                    unscheduledQuizzes: unscheduledEventsDisplayOrder.filter((e) => e.eventType === 'quiz')
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                // dispatch(getLessonData(lesson_id));
            });
    }
}

export function lockLesson(lesson_id, auth_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/lesson/lock',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ lesson_id, auth_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: LOCK_LESSON,
                    payload: auth_id
                });
            });
    }
}

export function unlockLesson(lesson_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/lesson/unlock',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ lesson_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: UNLOCK_LESSON,
                    payload: true,
                });
            });
    }
}

export function activateLesson(lesson_id, auth_id, courses) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/lesson/activate',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ lesson_id, auth_id, courses })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: ACTIVATE_LESSON,
                    payload: true,
                });
            });
    }
}

export function companyUpdateSearch(characters) {
    return {
        type: COMPANY_UPDATE_SEARCH,
        payload: characters
    }
}

export function toggleCompany(company, action_type) {
    return {
        type: TOGGLE_COMPANY,
        payload: { company, action_type }
    }
}


export function updateAssignmentEventTime(event) {
    return {
        type: UPDATE_EVENT,
        payload: event
    }
}

export function checkAssignmentEventAdd(event) {
    return {
        type: CHECK_EVENT_ADD,
        payload: event
    }
}

export function addUnscheduledEventOld(event) {
    return {
        type: ADD_UNSCHEDULED_EVENT_OLD,
        payload: event
    }
}

export function addUnscheduledEvent(source, destination, event_type, event_info) {
    return {
        type: ADD_UNSCHEDULED_EVENT,
        payload: { source, destination, event_type, event_info },
    }
}

export function moveUnscheduledEvent(source, destination, event_type, event_info) {
    return {
        type: MOVE_UNSCHEDULED_EVENT,
        payload: { source, destination, event_type, event_info },
    }
}

export function removeUnscheduledEvent(source, destination, event_type, event_info) {
    return {
        type: REMOVE_UNSCHEDULED_EVENT,
        payload: { source, destination, event_type, event_info },
    }
}

export function setUnscheduledEventRelation(event_relation, event_id) {
    return {
        type: SET_UNSCHEDULED_EVENT_RELATION,
        payload: { event_relation, event_id },
    }
}

/** Called right before a new item is added to unscheduled list. This sets the display orders of the unordered schedule and sets the new display order to the length of the list */
export function prepareDisplayOrders() {
    return {
        type: PREPARE_DISPLAY_ORDERS
    }
}

export function moveCard(dragIndex, hoverIndex, event) {
    return {
        type: MOVE_CARD,
        payload: { dragIndex: dragIndex, hoverIndex: hoverIndex, event: event }
    }
}

export function removeEventFromCalendar(event) {
    return {
        type: REMOVE_EVENT_FROM_CALENDAR,
        payload: event
    }
}

export function clearSchedule() {
    return {
        type: CLEAR_SCHEDULE,
        payload: true
    }
}

export function updateAssetName(newName, asset_id, saved) {
    return {
        type: UPDATE_ASSET_NAME,
        payload: { newName, asset_id, saved }
    }
}

export function updateNewLessonName(data) {
    return {
        type: UPDATE_NEW_LESSON_NAME,
        payload: data
    }
}

export function toggleLessonRepull(setting) {
    return {
        type: TOGGLE_LESSON_REPULL,
        payload: setting
    }
}

export function saveLessonCopy(lesson, auth_id, assignments, quizzes, unscheduledEvents, companies) {
    const create_id = lesson.lesson_id === 0 ? auth_id : lesson.CreateAuthID;
    const newLesson = {
        ...lesson,
        CreateAuthID: create_id,
        LastEditAuthID: auth_id
    }
    return async (dispatch, getState) => {
        await fetch(server_connection + '/lesson/save_copy',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    lesson: newLesson,
                    assignments,
                    quizzes,
                    unscheduledEvents,
                    companies
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                Promise.all([
                    dispatch(getLessonList('actions')),
                    dispatch({
                        type: TOGGLE_LESSON_REPULL,
                        payload: true,
                    }),
                    history.push({
                        pathname: '/lesson/edit/' + responseData.result
                    })
                ])
            });
    }
}


// WEBPACK FOOTER //
// src/main/content/lesson/store/actions/lesson.actions.js